import styled from "styled-components"

export const TableColumn = styled.td `
  text-transform: capitalize;
`
